import React from "react";
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';


import './BlankPage.css';


const BlankPage = () => {


    return (
        <div className="icon-wraper">
           <h1>This is the Blank Page</h1>
            <p><DashboardCustomizeOutlinedIcon /> Dashboard</p>
            <p><PersonOutlineOutlinedIcon /> Profile</p>
            <p><ScheduleOutlinedIcon /> Schedule</p>
            <p><PersonAddAltOutlinedIcon /> Refer a Friend</p>
            <p><EditCalendarOutlinedIcon /> Pickup Schedule</p>
            <p><DashboardCustomizeOutlinedIcon /> Dashboard</p>
            <p><PersonOutlineOutlinedIcon /> My Profile</p>
            <p><EventAvailableOutlinedIcon /> Schedule Interview</p>
            <p><InfoOutlinedIcon /> Personal Info</p>
            <p><BusinessOutlinedIcon /> Department</p>
            <p><WorkOutlineOutlinedIcon /> Designation</p>
            <p><GroupAddOutlinedIcon /> Sub User</p>
            <p><BusinessCenterOutlinedIcon /> Vendor</p>
            <p><GroupOutlinedIcon /> Vendor User</p>
            <p><WorkOutlineOutlinedIcon /> Post JOB</p>
            <p><PersonAddAltOutlinedIcon /> Add Profiles</p>
            <p><AssignmentTurnedInOutlinedIcon /> Apply Jobs</p>
            <p><VisibilityOutlinedIcon /> Viewed Profiles</p>
            <p><FilterListOutlinedIcon /> Shortlisted Profiles</p>
            <p><CheckCircleOutlineOutlinedIcon /> Applied Profiles</p>
            <p><Diversity3OutlinedIcon /> Interviews</p>
            <p><EditOutlinedIcon /> Edit Rating</p>
            <p><StarOutlineOutlinedIcon /> Skill</p>
            <p><StarOutlineOutlinedIcon /> Primary Skill</p>
            <p><StarOutlineOutlinedIcon /> Secondary Skill</p>
            <p><PersonOutlineOutlinedIcon /> Candidate</p>
            <p><PaymentOutlinedIcon /> ByPass PaymentGateway</p>
            <p><LockOutlinedIcon /> Passwords</p>
            <p><HowToRegOutlinedIcon /> Registered Candidates</p>
            <p><PersonSearchOutlinedIcon /> Interviewer</p>
            <p><EventNoteOutlinedIcon /> Interviewer Schedules</p>
            <p><VerifiedUserOutlinedIcon /> Registered Interviewers</p>
            <p><BusinessOutlinedIcon /> Company</p>
            <p><PersonAddAltOutlinedIcon /> Add Profiles</p>
            <p><ListOutlinedIcon /> All Profiles</p>
            <p><WorkOutlineOutlinedIcon /> Post Job</p>
            <p><StarOutlineOutlinedIcon /> View Rating</p>
            <p><BusinessOutlinedIcon /> Company OnBoard</p>
            <p><DashboardCustomizeOutlinedIcon /> Profiles Dashboard</p>
            <p><HowToRegOutlinedIcon /> Release Candidates</p>
            <p><PersonAddAltOutlinedIcon /> Add IAI User</p>
            <p><DateRangeOutlinedIcon /> Todays Follow-ups</p>
            <p><ReportProblemOutlinedIcon /> Client Escalations</p>
            <p><GroupOutlinedIcon /> Company Panels</p>
            <p><BusinessOutlinedIcon /> Company Profile</p>
            <p><WorkOutlineOutlinedIcon /> All Postings</p>
            <p><LocationCityOutlinedIcon /> City</p>
            <p><DomainOutlinedIcon /> Domain</p>
            



        </div>
    );
};
export default BlankPage;